// Portraits and profile PDFs of the team, keyed by member slug. The files are
// published here by Profil/scripts/build-cv.mjs from the profile source.
import adrianPhoto from './adrian-eisenmeier.jpg';
import adrianCvDe from './adrian-eisenmeier-cv-de.pdf';
import adrianCvEn from './adrian-eisenmeier-cv-en.pdf';
import nikolaiPhoto from './nikolai-genov.jpg';
import nikolaiCvDe from './nikolai-genov-cv-de.pdf';
import nikolaiCvEn from './nikolai-genov-cv-en.pdf';
import alinaPhoto from './alina-tselinina.jpg';
import alinaCvDe from './alina-tselinina-cv-de.pdf';
import alinaCvEn from './alina-tselinina-cv-en.pdf';

export const teamAssets = {
  'adrian-eisenmeier': { photo: adrianPhoto, cv: { de: adrianCvDe, en: adrianCvEn } },
  'nikolai-genov': { photo: nikolaiPhoto, cv: { de: nikolaiCvDe, en: nikolaiCvEn } },
  'alina-tselinina': { photo: alinaPhoto, cv: { de: alinaCvDe, en: alinaCvEn } }
};
